import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import PhoneField from 'components/v2/forms/PhoneField';

class LocationContact extends Component {
  static propTypes = {
    onContactChange: PropTypes.func.isRequired,
    contact: PropTypes.shape({
      name: PropTypes.string,
      phone: PropTypes.string,
    }),
  };

  static defaultProps = {
    contact: {
      name: '',
      phone: '',
    },
  };

  handleNameChange = (e) => this.props.onContactChange('name', e.target.value);
  handlePhoneChange = (phone) => this.props.onContactChange('phone', phone);

  render() {
    const {
      contact: { name, phone },
      t,
    } = this.props;

    return (
      <div className="grid grid-cols-2 gap-4">
        <div className="" id="contact-details">
          <label className="form-label mb-1">{t('CONTACT_NAME')}</label>
          <input
            type="text"
            className="form-field"
            placeholder={t('JOHN_SMITH')}
            onChange={this.handleNameChange}
            value={name}
            id="contact"
          />
        </div>

        <div className="" id="phone-details">
          <label className="form-label mb-1">{t('CONTACT_PHONE')}</label>
          <PhoneField
            value={phone}
            onChange={this.handlePhoneChange}
            id="phone"
          />
        </div>
      </div>
    );
  }
}

export default withTranslation()(LocationContact);
